module.exports = __webpack_public_path__ + "static/media/tj.77f4149e.svg";